export default "__VITE_ASSET__BRAidCb1__"